appSocial.service('LeaderCopyService', [
    '$rootScope', 'SocialTypes', 'SocialPortfolioService', 'SocialAPIService', 'SocialFavoriteService',
    function ($rootScope, SocialTypes, SocialPortfolioService, SocialAPIService, SocialFavoriteService) {

        class LeaderCopyService {
            constructor() {
                this.$rootScope = $rootScope;

                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;

                /**
                 * @type {SocialPortfolioService}
                 */
                this.portfolioService = SocialPortfolioService;

                /**
                 * @type {SocialFavoriteService}
                 */
                this.favoriteService = SocialFavoriteService;
            }

            /**
             * @param {string} leaderId
             * @param {number} deposit
             * @param {number} stopLoss
             * @param {boolean} copyOpen
             * @return {Promise<void>}
             */
            followByLeader(leaderId, deposit, stopLoss, copyOpen) {
                return this.api.request.followByLeader({
                    leader_id: leaderId,
                    deposit: Number(deposit),
                    stop_loss: (Number(deposit) * Number(stopLoss)) / 100,
                    copy_open: copyOpen
                })
                    .then(() => this.portfolioService.reload())
                    .then(() => this.favoriteService.reload());
            }

            /**
             * @param {string }followId
             * @return {Promise<void>}
             */
            unfollowLeader(followId) {
                return this.api.request.unfollowLeader('', {follow_id: followId})
                    .then(() => this.portfolioService.reload())
                    .then(() => this.favoriteService.reload());
            }

            /**
             *
             * @param {string} followId
             * @param {number} deposit
             * @param {number} stopLoss - in percents
             * @return {Promise<void>}
             */
            updateFunds(followId, deposit, stopLoss) {
                return this.api.request.updateFollowDeposit('', {
                    follow_id: followId,
                    deposit: Number(deposit),
                    stop_loss: (Number(deposit) * Number(stopLoss)) / 100
                })
                    .then(() => this.portfolioService.reload())
                    .then(() => this.favoriteService.reload());
            }

            /**
             * @param {string} followId
             * @param {boolean} state
             * @return {Promise<void>}
             */
            updateState(followId, state) {
                return this.api.request.updateFollowState('', {
                    follow_id: followId,
                    state: state
                })
                    .then(() => this.portfolioService.reload())
                    .then(() => this.favoriteService.reload());
            }

        }

        return new LeaderCopyService()
    }]);
